export const handleActionError = error => {
  console.log(error)
  return Promise.reject(error)
}
